import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";

const CardDeleteDialog = ({
  cardDeleteDialog,
  setCardDeleteDialog,
  handleDelete,
}) => {
  const handleClose = () => {
    setCardDeleteDialog(false);
  };
  const handleApprove = () => {
    handleDelete();
    setCardDeleteDialog(false);
  };

  return (
    <Dialog
      open={cardDeleteDialog}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Kayıtlı kredi kartınızı silmek üzeresiniz. Bu işleme devam etmek
          istediğinize emin misiniz?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="iyzi-button-blue" onClick={handleClose}>
          Hayır
        </Button>
        <Button className="iyzi-button-red" onClick={handleApprove} autoFocus>
          Evet
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CardDeleteDialog;
